export default __webpack_public_path__ + "static/media/icons-add-white-18-px.56f77dbb.svg";